import withAuthentication from 'components/withAuthentication';
import GatekeeperLoginForm from './GatekeeperLoginForm';

const ConnectedGatekeeperLoginForm = withAuthentication(GatekeeperLoginForm);
ConnectedGatekeeperLoginForm.displayName = 'ConnectedGatekeeperLoginForm';

export default ConnectedGatekeeperLoginForm;
